const Header = () => {
    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:pt-16 lg:pb-16 text-zinc-800 dark:text-zinc-200 text-sm">
            <div className="flex flex-cols items-end">
                <div className="lg:flex-none lg:w-9/12">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="hidden bg-purple-500 lg:inline-block h-2 w-2 rounded-full shadow-[0_0_8px_#a855f7]"></span>
                        <span className="hidden mt-4 lg:inline-block lg:mt-0 text-purple-600 dark:text-purple-400 uppercase font-sans text-xs tracking-widest font-semibold">Tier 1 Strategy</span>
                    </div>
                    <h1 className="py-4 text-4xl lg:text-6xl font-bold bg-gradient-to-r from-zinc-950 via-zinc-800 to-purple-900 dark:from-white dark:via-purple-100 dark:to-indigo-300 bg-clip-text text-transparent">
                        Enterprise AI & Strategy
                    </h1>
                    <p className="text-xs lg:text-base text-zinc-600 dark:text-zinc-400 font-light max-w-2xl leading-relaxed">
                        We bridge the gap between boardroom AI strategy and elite engineering execution. We help enterprise teams safely integrate Generative AI, overhaul developer workflows, and architect secure, compliant systems at scale.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Header